import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className='footer'>
            <div className='main-container footer-content'>
                <div className='footer-address'>
                    <small>Plot 7B, Lord Emmanuel Drive,</small>
                </div>
                <div className='footer-address1'>
                    <small>Rumuomasi, Port Harcourt, Rivers State, Nigeria.</small>
                </div>
            </div>

            <div className='main-container footer-content1'>
                <div className="footer-copyright">
                    <small>
                        &copy; {new Date().getFullYear()} Doumicom - All Rights Reserved.
                    </small>
                </div>

                <div className="footer-powered">
                    <small>
                        Powered By <a href="https://dataharborlb.net" target="_blank" rel="noreferrer">Dataharborlb </a><span>|</span> Designed by Eliane Elias
                    
                    </small>
                </div>
            </div>
        </footer>
    )
}

export default Footer